import { Button, Modal } from 'react-bootstrap';

function CustomModal({ className, title, message, buttons, onOk, onClose, ...props }) {
    return (
        <Modal
            {...props}
            onHide={onClose}
            show={onOk}
            dialogClassName={className}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                {buttons?.map((button, index) => {
                    const { name, variant, onClick } = button;
                    return (
                        <Button variant={variant} onClick={onClick} key={index}>{name}</Button>
                    )
                })}
            </Modal.Footer>
        </Modal>
    );
}

export default CustomModal;
